export const fonts = {
  regular: 'System',
  medium: 'System-Medium',
  semibold: 'System-Semibold',
  bold: 'System-Bold',
  light: 'System-Light',
} as const;

export type FontKey = keyof typeof fonts;
